import { paragraphStyle, subscribeToChannelBlock } from './index.css'

export const SubscribeToChannel = () => {
  return (
    <a
      target='_blank'
      href={import.meta.env.VITE_TELEGRAM_CHANNEL_URL}
      className={subscribeToChannelBlock}
      rel='noreferrer'
    >
      <p className={paragraphStyle}>Don't miss hot news</p>
      <p className={paragraphStyle}>Join our channel</p>
    </a>
  )
}
